export const classes = {
  paper:
    'rounded-2xl border border-white/70 bg-white/[0.94] shadow-glass backdrop-blur-[30px]',
  list: 'outline-none',
};

export const styles = {
  menu: {
    '& .MuiList-root': {
      minWidth: '120px',
      paddingTop: '0.25rem',
      paddingBottom: '0.25rem',
    },
  },
};
